import { gql } from '@apollo/client';

export const INSIGHTS_USER_QUERY = gql`
  {
    user {
      id
      name
      permissions
    }
  }
`;

export const GET_CAREPLANS_QUERY = gql`
  query careplansQuery(
    $page: Int
    $rowsPerPage: Int
    $search: String
    $status: [String]
    $priority: String
    $ordering: String
    $careplanChanged: [String]
    $onlyForRequestingPractitioner: Boolean
    $submittedBy: [String]
    $onOrBeforeDate: String
    $onOrAfterDate: String
    $insightsRequest: Boolean
  ) {
    careplans(
      page: $page
      rowsPerPage: $rowsPerPage
      search: $search
      status: $status
      priority: $priority
      ordering: $ordering
      careplanChanged: $careplanChanged
      onlyForRequestingPractitioner: $onlyForRequestingPractitioner
      submittedBy: $submittedBy
      onOrBeforeDate: $onOrBeforeDate
      onOrAfterDate: $onOrAfterDate
      insightsRequest: $insightsRequest
    ) {
      id
      careplanStatus
      careplanName
      diagnosisCode
      priority
      diagnosis {
        id
        diagnosisCode {
          diagnosisDescription
          tumourStream {
            name
          }
        }
      }
      submittedAt
      createdBy
      treatingDepartment
      patient {
        id
        ida
      }
      sitegroupSet {
        id
        siteSet {
          treatmentSite {
            treatmentSite
          }
          sitevaluesSet {
            field {
              name
            }
            value
          }
        }
      }
    }
  }
`;

export const DOCTOR_APPOINTMENT_QUERY = gql`
  query doctorAppointmentByDateWithPractioners(
    $startDate: DateTime
    $endDate: DateTime
    $appointmentActivities: [String]
    $excludeCancelled: Boolean
    $allPractitioners: Boolean
  ) {
    doctorAppointmentsByDateWithPractitioners(
      startDate: $startDate
      endDate: $endDate
      appointmentActivities: $appointmentActivities
      excludeCancelled: $excludeCancelled
      allPractitioners: $allPractitioners
    ) {
      id
      appointment {
        startTime
        patient {
          id
        }
        appointmentType
        location {
          name
          alias
        }
        description
        shortDescription
        activity
        practitioner {
          firstName
          lastName
        }
      }
      relatedPractitioners {
        practitioner {
          firstName
          lastName
        }
        relationshipType
      }
    }
  }
`;

export const TENANT_CONFIG_QUERY = gql`
  query tenantConfig {
    tenantConfig {
      id
      tenantName
      doseUnit
      insightsDefaultDateFilter
      insightsEmrDataSource
      insightsLinacs
      insightsDefaultDepartment
      insightsSimAppointmentActivities
      insightsTreatmentAppointmentActivities
      insightsExcludePhysicians
      insightsAdvancedAppointmentFiltering
      insightsDateRangeStart
      appointmentDescriptionSource
    }
  }
`;

export const GET_PATIENT_REPORT_QUERY = gql`
  query patientReportData($startDate: String, $endDate: String, $limit: Int, $offset: Int) {
    allPatients(createdAfter: $startDate, createdBefore: $endDate, limit: $limit, offset: $offset) {
      createdAt
      firstName
      lastName
      ida
      dob
      patientGender
      primaryPhone
      address {
        line1
        line2
        city
        state
        country
        postcode
      }
    }
  }
`;

export const DIAGNOSIS_TYPE = gql`
  fragment DiagnosisType on CarepathDiagnosisType {
    id
    isPrimaryDiagnosis
    stageType
    disease {
      title
      chapter
    }
    stageTCodePathological {
      subCode
    }
    stageNCodePathological {
      subCode
    }
    stageMCodePathological {
      subCode
    }
    stageTCodeClinical {
      subCode
    }
    stageMCodeClinical {
      subCode
    }
    stageNCodeClinical {
      subCode
    }
    morphology {
      displayName
    }
    laterality
    diagnosisDate
    diagnosisCode {
      diagnosisCode
      diagnosisDescription
      tumourStream {
        name
      }
    }
  }
`;

export const GET_DIAGNOSIS_REPORT_QUERY = gql`
  ${DIAGNOSIS_TYPE}
  query diagnosisQuery(
    $page: Int
    $rowsPerPage: Int
    $search: String
    $status: [String]
    $priority: String
    $ordering: String
    $careplanChanged: [String]
    $onlyForRequestingPractitioner: Boolean
    $submittedBy: [String]
    $onOrBeforeDate: String
    $onOrAfterDate: String
    $insightsRequest: Boolean
  ) {
    careplans(
      page: $page
      rowsPerPage: $rowsPerPage
      search: $search
      status: $status
      priority: $priority
      ordering: $ordering
      careplanChanged: $careplanChanged
      onlyForRequestingPractitioner: $onlyForRequestingPractitioner
      submittedBy: $submittedBy
      onOrBeforeDate: $onOrBeforeDate
      onOrAfterDate: $onOrAfterDate
      insightsRequest: $insightsRequest
    ) {
      id
      careplanStatus
      createdAt
      createdBy
      patient {
        ida
      }
      diagnosis {
        ...DiagnosisType
        relatedPrimaryDiagnosis {
          ...DiagnosisType
        }
      }
    }
  }
`;

export const GET_EARLIEST_PATIENT_DATE_QUERY = gql`
  query getEarliestPatientDate {
    earliestPatientDate
  }
`;
